import React, { useState } from 'react';
import { Box, SimpleGrid } from '@hover/blueprint';
import { navigate } from 'gatsby';
import { PRICING_PAGE_TABLE_HEADER } from '../../../../constants';
import { IPricingTableHeader } from '../../../../interfaces/IPricingTableHeader';
import HeaderCard from '../HeaderCard';
import { DownloadAppModal } from '../../../common';

const HeaderCards: React.FC = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const toggleModal = () => setOpen(!isOpen);

  const onLinkClick = (card: IPricingTableHeader) => {
    if (card.type === 'The Basics') {
      toggleModal();
    } else if (card.linkTo) {
      void navigate(card?.linkTo);
    }
  };
  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <SimpleGrid columns={6} spacing={600} mb="28px">
        {PRICING_PAGE_TABLE_HEADER.map((card: IPricingTableHeader) => {
          if (card.id) {
            return (
              <HeaderCard onLinkClick={onLinkClick} key={card.id} card={card} />
            );
          }
          return <Box key={card.id} />;
        })}
      </SimpleGrid>
    </>
  );
};

export default HeaderCards;
